// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { useMutation } from '@tanstack/react-query'

import { type Tag } from '../../brokers/types'
import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

type CreateOrEditTagParams = {
  id?: string
  category: string
  name: string
  description?: string
  temporary?: boolean
}

export function useCreateOrEditTag ({ isCreate }: { isCreate: boolean }) {
  return useMutation<Tag, GrapeAPIErrorType, CreateOrEditTagParams>({
    mutationFn: async (params) => {
      const request = new FetchRequest(
        isCreate ? 'post' : 'patch',
        isCreate
          ? '/api/web/brokers/tags'
          : `/api/web/brokers/tags/${params.id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: {
            ...params,
          },
        }
      )
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return response.json
    },
  })
}
